const fvSwiper = new Swiper('.fv__swiper', {
  loop: true,
  speed: 1200,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
});

const MOBILE_BREAKPOINT = 767;
const DESIGN_RATIO = 870 / 1440;

function adjustFvHeight() {
  const fv = document.querySelector('.fv');
  const content = document.querySelector('.fv__content');
  if (!fv || !content) return;

  fv.style.height = '';

  let finalHeight;
  if (window.innerWidth > MOBILE_BREAKPOINT) {
    finalHeight = Math.min(window.innerHeight, window.innerWidth * DESIGN_RATIO);
  } else {
    const needed = content.offsetTop + content.offsetHeight + 40;
    finalHeight = Math.max(window.innerHeight, needed);
  }

  fv.style.height = finalHeight + 'px';
  fvSwiper.update();
}

window.addEventListener('load', adjustFvHeight);
window.addEventListener('resize', adjustFvHeight);
